export default {
  views: {
    product: {
      plans: {
        title: '选择套餐'
      },
      cancelPolicy: {
        title: '取消政策'
      },
      recommendations: {
        title: '其他推荐'
      },
      panels: {
        selectDate: '选择日期',
        selectPlan: '选择套餐',
        selectPeople: '选择人数',
        options: '附加商品',
        profile: '个人资料'
      },
      auth: {
        loginOrRegister: '登录 / 注册'
      }
    },
    book: {
      title: '订单确认',
      bookingNotice: '请在预订前确认',
      paymentConfirmation: '请在支付前确认',
      tip: '为确认订单，请在15分钟内完成操作',
      sessionInfo: '预订信息'
    },
    bookConfirm: {
      productInfo: '商品信息',
      sessionConfirmed: '已确认',
      sessionUnconfirmed: '未确认',
      paymentInfo: '支付信息',
      paymentConfirmation: {
        warningTitle: '请确认取消政策：',
        warningText: '该商品一旦购买将无法退款。',
        agreementText: '我已确认并同意'
      },
      prePaymentConfirmation: {
        title: '支付前确认事项',
        checkInput: '请确认输入内容是否正确。',
        emailNotice:
          '注意：如果您设置了域名邮件过滤，请在预约前将"@linktivity.co.jp"添加到白名单。',
        agreementText: '我已确认并同意上述事项。'
      },
      paymentAmount: {
        total: '支付金额（含税）',
        details: '详细',
        note: '日元以外的币种金额为依据当前汇率计算的预估金额，与实际扣款金额可能略有差异，仅供参考。'
      },
      confirmPaymentDialogTitle: '付款确认',
      participantInfo: {
        title: '参与者信息',
        dialogTitle: '修改参与者信息',
        change: '变更',
        password: '密码',
        validation: {
          passwordRequired: '请输入密码'
        }
      },
      couponApplied: '优惠券已成功使用',
      couponFailed: '优惠券使用失败',
      couponRemoved: '优惠券已成功移除',
      couponRemoveFailed: '优惠券移除失败',
      actionButtons: {
        back: '返回',
        toPayment: '去支付'
      }
    },
    voucher: {
      pdf: '打印用PDF',
      html: '凭证'
    },
    bookingDetail: {
      title: '预订详情',
      detailInfo: '预订详情',
      startDate: '参加日期',
      validityPeriod: '有效期',
      voucherInfo: '凭证',
      digitalTicket: '电子票',
      invoice: '收据/发票',
      invoiceSend: '开具',
      invoiceSent: '发票已开具',
      redemption: '使用电子票',
      meetingPoint: '入场位置指南',
      beforeTrip: '使用前确认事项',
      bookingAction: '预订操作',
      cancelBooking: '取消预订',
      cancelConfirmPolicy: '请确认取消政策：',
      customerName: '预订人',
      actualPayment: '支付金额',
      refundAmount: '退款金额',
      orderId: '预订ID',
      orderCompletionTime: '预订时间',
      digitalTicketValidPeriod: 'QR码仅在使用当天有效',
      digitalTicketWaiting: '*订单确认后，电子票将在此显示',
      sending: '发送中...',
      sendToEmail: '发送至邮箱',
      cancelConfirm: '是否确认取消预订？',
      cancelFee: '取消费用',
      cancelRemarkSelect: '请选择取消原因',
      inclusion: '包含的物品',
      checklist: '注意事项',
      restrictions: '参加制限',
      requirements: '参加前・参加时必要事项',
      attireItems: '参加时必要服装・持物',
      otherInfo: '备注・其他',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: '图片'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: '其他',
      CANCEL_REASON_MODIFY_BOOKING: '变更预订日期或人数',
      CANCEL_REASON_BOOKED_BY_MISTAKE: '误订',
      CANCEL_REASON_DUPLICATE_BOOKING: '因重复预订',
      CANCEL_REASON_HEALTH_CONDITION: '生病',
      CANCEL_REASON_TRANSPORTATION_ISSUE: '航班取消、延误或变更',
      CANCEL_REASON_SCHEDULE_CONFLICT: '行程有变',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: '改订为其他商品'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    home: {
      title: 'Triplabo',
      header: {
        alt: 'Triplabo'
      },
      search: {
        placeholder: '搜索商品'
      },
      ticketList: {
        title: '票券一览'
      },
      enjoyPack: {
        title: '畅游套餐'
      }
    }
  }
};
